import { apiFetchJson } from "@rook/shared/lib/apiFetch";

/**
 * Session shape returned by `GET /api/auth/session`.
 *
 * The BFF Lambda (`amplify/functions/auth-session/handler.ts`) reads
 * the HttpOnly cookie, verifies the JWT, returns a minimal
 * projection. The cookie itself is invisible to the SPA — we only
 * see the claims here.
 *
 * `ok: false` is the "no session" branch. The Lambda intentionally
 * uses 200+`{ok:false}` instead of 401 so the AuthProvider's mount
 * probe doesn't paint dev-tools red on every cold start of the login
 * page. The AuthGuard checks `ok`, NOT a HTTP status.
 */
export type Session =
  | { ok: false }
  | {
      ok: true;
      email: string;
      clientId: string;
      groups: string[];
      expiresAt: string;
      /**
       * ENV entitlements (client-bound, CPF-NFR-024). Populated by the
       * LANDING's auth-session, which reads `cpf-owner-entitlements`;
       * the landing's post-login handoff routes on `isProductionActive`
       * (prod-active → production portal, else sandbox). Optional
       * because the PORTAL's own session probe (P-030) doesn't project
       * these — only the landing needs them for routing.
       */
      isProductionActive?: boolean;
      /** Envs the customer may enter (e.g. ["sandbox","production"]). */
      envAccess?: string[];
    };

export const fetchSession = (): Promise<Session> =>
  apiFetchJson<Session>("/api/auth/session");
